



















































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Account } from "@/models/account";
import loader from "@/components/loader.vue";
import billingApi from "@/services/billing";
import { Getter, Action, Mutation } from "vuex-class";
import moment from "moment";

import { NSLog } from "@/helpers/log";
import { ServiceMatrix, ServiceMatrixUser } from "@/models/serviceMatrix";
import { Warehouse } from "@/models/warehouse";
import AccountCell from "@/components/cells/Account.vue";
import { find as FindAccountDialog } from "@/dialogs/account";

const log = NSLog("view/manage/MatrixVisibillity");

const FRIENDLY_SHIPPING_PROVIDER_MAP: { [key: string]: string } = {
  SHPFixedUSToUS: "Fixed US to US",
  SHPFixedZAToZA: "Fixed ZA to ZA",
  FreshEffects: "Fresh-effects",
  SHPZALexieToZA: "Fixed Lexie ZA to ZA"
};

@Component({
  components: {
    loader,
    AccountCell,
    FindAccountDialog
  },
})
export default class MatrixVisibillity extends Vue {
  private loading = true;
  searchAccountDialog = false;
  @Mutation("setLastErr") private setLastErr: any;

  @Getter("warehouses") warehouses!: Warehouse[];
  serviceMatricesRaw: ServiceMatrix[] = [];
  serviceMatricesUsers: ServiceMatrixUser[] = [];
  selectedMatrix: ServiceMatrix | null = null;

  async toggleMatrixActive(matrixId: number, active: boolean) {
    this.loading = true;
    try {
      await billingApi.updateServiceMatrix(matrixId, active);
    } catch (err) {
      this.setLastErr(err);
    }
    this.loading = false;
  }

  async addServiceMatrixAccount(matrixId: number, userID: number) {
    this.loading = true;
    try {
      await billingApi.addServiceMatricesUser(matrixId, userID);
      await this.loadServiceMatricesUsers();
    } catch (err) {
      this.setLastErr(err);
    }
    this.loading = false;
  }

  async deleteServiceMatrixAccount(matrixId: number, userID: number) {
    this.loading = true;
    try {
      await billingApi.removeServiceMatricesUser(matrixId, userID);
      await this.loadServiceMatricesUsers();
    } catch (err) {
      this.setLastErr(err);
    }
    this.loading = false;
  }

  searchDialogEvent(account: Account | false) {
    if (!account || !this.selectedMatrix) {
      this.searchAccountDialog = false;
      return;
    }
    this.searchAccountDialog = false;
    this.loading = true;
    this.addServiceMatrixAccount(this.selectedMatrix.id, account.id);
    this.loading = false;
  }

  mounted() {
    this.loadServiceMatrices();
    this.loadServiceMatricesUsers();
  }

  async loadServiceMatrices() {
    this.loading = true;
    try {
      this.serviceMatricesRaw = await billingApi.listServiceMatrices(true);
    } catch (err) {
      this.setLastErr(err);
    }
    this.loading = false;
  }

  async loadServiceMatricesUsers() {
    this.loading = true;
    try {
      this.serviceMatricesUsers = await billingApi.listServiceMatricesUsers();
    } catch (err) {
      this.setLastErr(err);
    }
    this.loading = false;
  }

  get serviceMatrices() {
    return this.serviceMatricesRaw
      .map((s) => {
        const wh = this.warehouses.find((wh) => s.warehouse_id == wh.id);

        return {
          ...s,
          payment_provider: (s.payment_provider || "None")
            .replaceAll(/[_-]/gi, " ")
            .toUpperCase(),
          billing_provider: (s.billing_provider || "None")
            .replaceAll(/[_-]/gi, " ")
            .toUpperCase(),
          email_provider: (s.email_provider || "None")
            .replaceAll(/[_-]/gi, " ")
            .toUpperCase(),
          tax_provider: (s.tax_provider || "None")
            .replaceAll(/[_-]/gi, " ")
            .toUpperCase(),
          shipping_provider:
            FRIENDLY_SHIPPING_PROVIDER_MAP[s.shipping_provider || ""] ||
            s.shipping_provider,
          warehouse: wh ? wh.name : "",
        };
      });
  }

  usersForServiceMatrix(serviceMatrixID: number) {
    return this.serviceMatricesUsers.filter((smu) => smu.service_matrix_id == serviceMatrixID)
  }

  get headers() {
    return [
      // { text: "Id", value: "id" },
      { text: "Active", value: "active" },
      { text: "Show Users", value: "users" },
      { text: "Ship from warehouse", value: "warehouse" },
      { text: "Ship from region", value: "src_region" },
      { text: "Destination region", value: "dst_region" },
      { text: "Invoice Currency", value: "invoice_currency" },
      { text: "Charge Currency", value: "bill_currency" },
      { text: "Billing Provider", value: "billing_provider" },
      { text: "Payment Provider", value: "payment_provider" },
      { text: "Email Provider", value: "email_provider" },
      { text: "Tax Provider", value: "tax_provider" },
      { text: "Shipping Provider", value: "shipping_provider" },
    ];
  }

  get userHeaders() {
    return [
      { text: "Account ID", value: "account_id" },
      { text: "First Name", value: "account_id" },
      { text: "Last Name", value: "account_id" },
      { text: "Email", value: "account_id" },
      { text: "Actions", value: "id" },
    ];
  }

  pagination = {
    descending: true,
    page: 0,
    rowsPerPage: -1, // -1 for All",
    sortBy: 'active',
    // totalItems: 9999
  };
}
